import { Injectable } from '@angular/core';

@Injectable()
export class ClipboardCopyService {

    copyTextToClipboard(text: string) 
    {
        let textArea = document.createElement("textarea");

        textArea.value = text;
        
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";
      
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
    
        document.execCommand('copy');
    
        document.body.removeChild(textArea);
    }

}